import React from 'react'
import PropTypes from 'prop-types'

import styles from './AnswerCorrectIndicator.css'

class AnswerCorrectIndicator extends React.Component {
  render () {
    let {id, children} = this.props

    const outerClasses = 'hw-answer-correct-indicator ' + styles.answer_correct_indicator
    const wrapperClasses = 'hw-answer-correct-indicator-wrapper ' + styles.answer_correct_indicator_wrapper
    const iconClasses = 'hw-answer-correct-indicator-icon ' + styles.answer_correct_indicator_icon
    const checkmarkClasses = 'hw-answer-correct-indicator-icon ' + styles.answer_correct_indicator_checkmark
    const indicatorTextClasses = 'hw-answer-correct-indicator-text ' + styles.answer_correct_indicator_text

    return (
      <span className={outerClasses} id={id}>
        <span className={wrapperClasses} >
          <svg role="presentation" className={iconClasses} width="23" height="18" focusable="false">
            <g className={checkmarkClasses}>
              <line y2="14.78125" x2="9.190340" y1="9.525510" x1="2.40625" strokeWidth="2" />
              <line y2="2.406250" x2="20.46875" y1="14.84056" x1="7.86972" strokeWidth="2" />
            </g>
          </svg>
          <span className={indicatorTextClasses}>{children}</span>
        </span>
      </span>
    )
  }
}

AnswerCorrectIndicator.propTypes = {
  id: PropTypes.string,
  children: PropTypes.string
}

AnswerCorrectIndicator.defaultProps = {
  children: 'Correct'
}

export default AnswerCorrectIndicator



// WEBPACK FOOTER //
// /src/~/@healthwise/enhanced-shared-decision-point/components/AnswerCorrectIndicator/index.js